const THEME_OPTIONS = {
  light: 'light',
  dark: 'dark',
};

export const { light, dark } = THEME_OPTIONS;
